import React from 'react';

const TildeIcon = (props: { textColor: string }) => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1.5C0 0.947715 0.447715 0.5 1 0.5H11C11.5523 0.5 12 0.947715 12 1.5V11.5C12 12.0523 11.5523 12.5 11 12.5H1C0.447715 12.5 0 12.0523 0 11.5V1.5Z"
        fill={props.textColor}
      />
      <path
        d="M1.87524 7.616C2.24858 6.752 2.66991 6.13333 3.13924 5.76C3.61924 5.376 4.12591 5.184 4.65924 5.184C4.98991 5.184 5.27791 5.248 5.52324 5.376C5.76858 5.49333 5.99258 5.62667 6.19524 5.776C6.39791 5.91467 6.58991 6.04267 6.77124 6.16C6.96324 6.27733 7.16591 6.336 7.37924 6.336C7.59258 6.336 7.79524 6.224 7.98724 6C8.17924 5.776 8.34991 5.46133 8.49924 5.056L10.1312 5.824C9.75791 6.688 9.33124 7.312 8.85124 7.696C8.38191 8.06933 7.88058 8.256 7.34724 8.256C7.00591 8.256 6.71258 8.19733 6.46724 8.08C6.23258 7.96267 6.01391 7.83467 5.81124 7.696C5.60858 7.54667 5.41124 7.41333 5.21924 7.296C5.03791 7.168 4.84058 7.104 4.62724 7.104C4.41391 7.104 4.21124 7.216 4.01924 7.44C3.82724 7.664 3.65658 7.97867 3.50724 8.384L1.87524 7.616Z"
        fill="white"
      />
    </svg>
  );
};

export default TildeIcon;
